import { getAllUnidadesMedida } from '../../../../../../../../crud/configuration_api/unidades_medida';
import { getAllItemHolderCategoriesByLocalId } from '../../../../../../../../crud/menu_api/categories';
import { Option } from '../../types';

export const getUnidadesMedidaOptions = async () => {
  // it should return a map of workstation names and ids
  const response = await getAllUnidadesMedida();
  if (response) {
    const data = response.data;
    if (data) {
      const ums: Option[] = data.map((um: any) => {
        return {
          id: um.unidad_medida_id,
          name: um.name + " - " + um.acronym,
        };
      });
      return ums;
    }
  }
  return [];
};


export const getCategoryOptions = async () => {
  // Siempre obtener las categorías, sin importar el valor de categoryId
  const userContext = localStorage.getItem('user');
  const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
  const response = await getAllItemHolderCategoriesByLocalId(localId);
  if (response) {
    const data = response.data;
    if (data) {
      const categories: Option[] = data.map((category: any) => {
        return {
          id: category.category_id,
          name: category.category_name,
        };
      });
      // Ordenar por nombre
      categories.sort((a, b) => a.name.localeCompare(b.name));
      return categories;
    }
  }
  return [];
}